module.exports = __webpack_public_path__ + "img/santuyplay.7803e953.jpg";